import {
    accessDelegationExample,
    accessImpersonationsExample,
    accessTokensExample,
} from "@/mock-api/data/accessExample.ts";
import { billingAccountCardsExample } from "@/mock-api/data/billingAccountCardsExample.ts";
import { billingAccountHistoryExample } from "@/mock-api/data/billingAccountHistoryExample.ts";
import { billingAccountInvoicesExample } from "@/mock-api/data/billingAccountInvoicesExample.ts";
import { billingAccountUsageExample } from "@/mock-api/data/billingAccountUsageExample.ts";
import { bootImagesExample } from "@/mock-api/data/bootImagesExample.ts";
import { campaignsExample } from "@/mock-api/data/campaignsExample.ts";
import { demoBillingAccountsExample, demoStorageList } from "@/mock-api/data/demoDataExample.ts";
import { disksList } from "@/mock-api/data/disksExample.ts";
import { firewallList1, firewallList2 } from "@/mock-api/data/firewallsExample.ts";
import { googleTagManagerExample } from "@/mock-api/data/googleTagManagerExample.ts";
import { hostPools1, hostPools2 } from "@/mock-api/data/hostPoolsExample.ts";
import { ipList1, ipList2 } from "@/mock-api/data/ipAddressesExample.ts";
import { lbList1, lbList2 } from "@/mock-api/data/loadBalancersExample.ts";
import { loc1Tll, loc2Jhv } from "@/mock-api/data/locationsExample.ts";
import { metalExampleConfig, metalExampleData, metalExampleLocationConfig } from "@/mock-api/data/metalExample.ts";
import { referralAmountsExample } from "@/mock-api/data/referralAmountsExample.ts";
import { referralEnabledExample } from "@/mock-api/data/referralEnabledExample.ts";
import { serviceImagesList } from "@/mock-api/data/serviceImagesExample.ts";
import { serviceSecretsExample, servicesList, serviceWhitelistExample } from "@/mock-api/data/servicesExample.ts";
import { sshKeysExample } from "@/mock-api/data/sshKeysExample.ts";
import { storageAccounts } from "@/mock-api/data/storageExample.ts";
import { storageKeys } from "@/mock-api/data/storageKeyExample.ts";
import { userExample } from "@/mock-api/data/userExample.ts";
import { vmList1, vmList2 } from "@/mock-api/data/vmExample.ts";
import { vmImagesExample } from "@/mock-api/data/vmImagesExample.ts";
import { vmInterfaces, vpcList1, vpcList2 } from "@/mock-api/data/vpcNetworksExample.ts";
import type { MockDbData } from "@/mock-api/defaultDb.ts";

export function demoDb() {
    return {
        locationsData: {
            [loc1Tll]: {
                ...metalExampleLocationConfig,
                ...metalExampleData,
                vms: vmList1,
                ipAddresses: ipList1,
                vpcNetworks: vpcList1,
                loadBalancers: lbList1,
                vmInterfaces: vmInterfaces,
                firewalls: firewallList1,
                hostPools: hostPools1,
                disks: disksList,
            },
            [loc2Jhv]: {
                metalSpecs: [],
                metalMachines: [],
                metalLeases: [],
                metalStates: [],
                metalCommitments: [],
                metalCommitmentOffers: [],
                vms: vmList2,
                ipAddresses: ipList2,
                vpcNetworks: vpcList2,
                loadBalancers: lbList2,
                vmInterfaces: vmInterfaces,
                firewalls: firewallList2,
                hostPools: hostPools2,
                disks: [],
            },
        },
        storages: demoStorageList,
        storageKeys,
        storageAccounts: storageAccounts,
        services: servicesList,
        serviceImages: serviceImagesList,
        serviceWhitelist: serviceWhitelistExample,
        serviceSecrets: serviceSecretsExample,
        tokens: accessTokensExample,
        delegations: accessDelegationExample,
        impersonations: accessImpersonationsExample,
        billingAccounts: demoBillingAccountsExample,
        billingCards: billingAccountCardsExample,
        billingUsage: billingAccountUsageExample,
        billingHistory: billingAccountHistoryExample,
        billingInvoices: billingAccountInvoicesExample,
        vmImages: vmImagesExample,
        sshKeys: sshKeysExample,
        bootImages: bootImagesExample,
        users: [userExample],
        campaigns: campaignsExample,
        referral_enabled: referralEnabledExample,
        referral_amounts: referralAmountsExample,
        gtm_key: googleTagManagerExample,

        ...metalExampleConfig,
    } satisfies MockDbData;
}
